export const config = {
  api: {
    baseUrl: import.meta.env.VITE_API_BASE_URL || 'http://localhost:8000',
    // The agent chat service runs on its own origin in local dev; everywhere
    // else it shares `baseUrl`, so this is unset outside `.env`.
    chatBaseUrl:
      import.meta.env.VITE_CHAT_BASE_URL ||
      import.meta.env.VITE_API_BASE_URL ||
      'http://localhost:8000',
    // The standalone local chat service serves the chat endpoint at its own root;
    // on the shared origin the agent lives under /agent, so prefix it there.
    chatPath: import.meta.env.VITE_CHAT_BASE_URL ? '/demo/chat' : '/agent/demo/chat',
    // The zonal stats service can live on a different origin to `baseUrl` (staging
    // reads production's stats). Empty means it shares `baseUrl`.
    zonalStatsBaseUrl: import.meta.env.VITE_ZONAL_STATS_BASE_URL || '',
    timeout: 10000,
  },
  map: {
    /** Base URL for the internal tile server. Empty string in dev — Vite proxies /tiles to localhost:9000. */
    tilesBaseUrl: import.meta.env.VITE_TILES_URL || '',
    tilesUrlPublic: 'https://mt1.google.com/vt/lyrs=s&x={x}&y={y}&z={z}',
    tilesUrlPublicRoad: 'https://mt1.google.com/vt/lyrs=m&x={x}&y={y}&z={z}',
    /** Transparent roads + place-name labels overlay, drawn crisp on top of a dimmed base. */
    tilesUrlPublicLabels: 'https://mt1.google.com/vt/lyrs=h&x={x}&y={y}&z={z}',
    tilesUrlAuthenticated: 'https://tile.googleapis.com/v1/2dtiles/{z}/{x}/{y}',
    /** Mints the session token a tile URL carries — one per map type and styling. */
    tilesSessionUrl: 'https://tile.googleapis.com/v1/createSession',
    defaultCenter: [0, 0] as [number, number],
    defaultZoom: 2,
    googleMapsApiKey: import.meta.env.VITE_GOOGLE_MAPS_API_KEY,
    /**
     * The planetary opening played on a fresh map landing (no deep-link). It only
     * holds the globe still; the project-bounds auto-fit flies it in from there.
     */
    intro: {
      startCenter: [50, 20] as [number, number],
      startZoom: 2.5,
      holdMs: 2000,
    },
  },
  waf: {
    /**
     * Base URL of the AWS WAF JS SDK for the environment's web ACL (Terraform output
     * `waf_application_integration_url`). The signup form loads it to mint the token the WAF's
     * bot rules check. Set for production and staging; see docs/WAF.md.
     */
    integrationUrl: import.meta.env.VITE_AWS_WAF_INTEGRATION_URL || '',
    /**
     * Base URL of the AWS WAF CAPTCHA SDK and its API key (Terraform output `waf_captcha_api_key`),
     * for when a bot rule answers with a CAPTCHA. Set for production and staging.
     */
    captchaUrl: import.meta.env.VITE_AWS_WAF_CAPTCHA_URL || '',
    captchaApiKey: import.meta.env.VITE_AWS_WAF_CAPTCHA_API_KEY || '',
  },
  posthog: {
    key: import.meta.env.VITE_POSTHOG_KEY,
    host: import.meta.env.VITE_POSTHOG_HOST,
    environment: import.meta.env.MODE,
  },
  mocks: {
    /**
     * Story chapter stats + AI summaries answer from generated data instead of the
     * stats and summary services, which run on their own local origins most dev
     * setups don't start. Opt in with `VITE_MOCK_STORY_DATA=true`; anything else,
     * including an unset var, hits the real services.
     */
    storyData: import.meta.env.VITE_MOCK_STORY_DATA === 'true',
  },
  app: {
    name: 'NabatOS',
    version: import.meta.env.VITE_APP_VERSION || '1.0.0',
    basename: import.meta.env.VITE_BASE_PATH || '/',
  },
} as const;
